exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger[data-v-0bb429ca] {\n\tdisplay: inline-block;\n\tcursor: pointer;\n\twidth: 20px;\n\theight: 20px;\n\t-webkit-transform: rotate(90deg);\n\t        transform: rotate(90deg);\n\t-webkit-transition: .38s;\n\ttransition: .38s;\n\t-webkit-transform-origin: 50% 50%;\n\t        transform-origin: 50% 50%;\n}\n.hamburger.is-active[data-v-0bb429ca] {\n\t-webkit-transform: rotate(0deg);\n\t        transform: rotate(0deg);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0bb429ca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/feige/components/Hamburger/index.vue
// module id = 338
// module chunks = 75